import script from "./ProductItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductItem.vue?vue&type=script&setup=true&lang=js"

import "./ProductItem.vue?vue&type=style&index=0&id=070032bf&lang=scss"

const __exports__ = script;

export default __exports__